import React from "react";
import styled from "styled-components/macro";
import { useSelector } from "react-redux";

import { useBreakpoint } from "../../utilities/media-js-breakpoints";
import { getImageUrl } from "../../store/sagas/selectors";
import Constants from "../../constants";

const ConfigurationImage = styled.img`
    pointer-events: auto;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    position: relative;
    min-height: 100%;
    max-height: 100%;
    height: max-content;
    max-width: unset;
`;

const ImagesContainer = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: 100vw;
    z-index: 0;
`;

export const ConfiguratorImages = () => {
    const breakpoints = useBreakpoint();
    const imageUrl = useSelector(getImageUrl);

    let height;
    if (breakpoints.landscape) {
        height = `${Constants.desktopImageHeightPercent}%`;
    } else {
        height = `${Constants.mobileImageHeightVw}vw`;
    }

    return (
        <ImagesContainer style={{ height }}>
            <ConfigurationImage alt="alt" src={imageUrl || ""} />
        </ImagesContainer>
    );
};
